<template>
  <RestaurantRequestsList/>
</template>
<script>
import RestaurantRequestsList from '@/components/modules/restaurant/requests/list'
export default {
  name: 'RestaurantRequests',
  components: {
    RestaurantRequestsList
  }
}
</script>



// WEBPACK FOOTER //
// src/views/restaurant/requests/list.vue